/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Auto_Crop_FailedInputs */

const en_mobile_scan_auto_crop_failed = /** @type {(inputs: Mobile_Scan_Auto_Crop_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto crop could not finish. Try again or adjust the corners manually.`)
};

const es_mobile_scan_auto_crop_failed = /** @type {(inputs: Mobile_Scan_Auto_Crop_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo completar el ajuste automático. Inténtalo de nuevo o ajusta las esquinas manualmente.`)
};

/**
* | output |
* | --- |
* | "Auto crop could not finish. Try again or adjust the corners manually." |
*
* @param {Mobile_Scan_Auto_Crop_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_auto_crop_failed = /** @type {((inputs?: Mobile_Scan_Auto_Crop_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Auto_Crop_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_auto_crop_failed(inputs)
	return en_mobile_scan_auto_crop_failed(inputs)
});